import {colors} from '@/assets/tailwindcss/colors'
import {Checkbox, Icon, Text} from '@/components/atoms'
import {useGetAllGtins} from '@/hooks/promotion/useGetAllGTINs'
import {useDebounce} from '@/hooks/useDebounceValue'
import {COLOR_CODE} from '@/utils/constants/colors'
import {DEFAULT_TABLE_PAGE_SIZE} from '@/utils/constants/commonConstants'
import debounce from 'lodash/debounce'
import {LoadingSpinner, Pagination, Search} from 'pepsico-ds'
import {useCallback, useState} from 'react'

export const GTINSelection = ({selectedGtins, handleGtinCheckbox, setCurrentSelectedGtin}) => {
  const [page, setPage] = useState(0)
  const [search, setSearch] = useState('')

  const resetPage = useCallback(() => {
    setPage(0)
  }, [])

  const debouncedSearchValue = useDebounce(search, 300, resetPage)
  const {data: allGtinsData, isLoading} = useGetAllGtins(page, DEFAULT_TABLE_PAGE_SIZE, debouncedSearchValue)

  //TODO remove this when the peacock problem is fixed
  // PEACOCK PROBLEM AGAIN, updateValue is called twice when checkbox is clicked
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleCheckboxChange = useCallback(
    debounce((value, gtinId) => handleGtinCheckbox(value, gtinId), 50),
    [handleGtinCheckbox]
  )

  const handleNextPage = newPageIndex => {
    setPage(newPageIndex - 1)
    setCurrentSelectedGtin('')
  }

  return (
    <div className="flex min-w-[360px] flex-col border-r border-[#4E4E4E] px-4">
      <div className={`flex flex-col gap-4 py-4`}>
        <Text headingLevel={4} variant={'bold'} isDark>
          {'GTIN'}
        </Text>
        <Text className={`border-b border-[${colors.gray['600']}]`} size="small">
          {selectedGtins.length} item(s) selected
        </Text>
        <Search onUpdate={value => setSearch(value)} placeholderText="Search GTIN" />
      </div>
      {isLoading ? (
        <div className="flex h-[450px] flex-col items-center justify-center px-4">
          <LoadingSpinner />
        </div>
      ) : (
        <>
          <div className="flex flex-col">
            {allGtinsData?.data?.map(({gtinId, productCount}) => {
              const isSelected = Boolean(selectedGtins?.find(item => item.id === gtinId))

              return (
                <div
                  key={gtinId}
                  className={`${isSelected ? 'bg-[#272727]' : 'transparent'} flex flex-1 flex-row items-center gap-2 p-2`}
                >
                  <Checkbox
                    label={
                      <Text className="ml-2" variant={'bold'} isDark>
                        {gtinId}
                      </Text>
                    }
                    updateValue={value => handleCheckboxChange(value, gtinId)}
                    value={isSelected}
                  />
                  <div className="flex flex-1 flex-row justify-between">
                    <div className="flex flex-1 flex-col items-start gap-1"></div>
                    <div
                      className="flex cursor-pointer items-center gap-4"
                      onClick={() => setCurrentSelectedGtin(gtinId)}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault()
                          setCurrentSelectedGtin(gtinId)
                        }
                      }}
                      role="button"
                      tabIndex={0}
                      aria-label={`View ${productCount} products for GTIN ${gtinId}`}
                    >
                      <Text variant="bold" size="small" style={{color: COLOR_CODE._66A5E7}}>
                        {productCount}
                      </Text>
                      <Icon icon="chevron_right" className="text-[#66A5E7]" size="small" />
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          <div className="flex w-full justify-center py-4">
            <Pagination currentPage={page + 1} onUpdate={handleNextPage} isDark pageCount={allGtinsData?.totalPages} />
          </div>
        </>
      )}
    </div>
  )
}
